import React from "react";

const NotFoundPage = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-sdbodywhite">
      <img
        src="/image-fix/error 404.gif"
        alt="Not Found"
        className="max-w-full max-h-full"
      />
    </div>
  );
};

export default NotFoundPage;
